import { render, staticRenderFns } from "./CreateCompetitons.vue?vue&type=template&id=52659eda&scoped=true"
import script from "./CreateCompetitons.vue?vue&type=script&lang=js"
export * from "./CreateCompetitons.vue?vue&type=script&lang=js"
import style0 from "./CreateCompetitons.vue?vue&type=style&index=0&id=52659eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52659eda",
  null
  
)

export default component.exports